ticket.ticketCombiModule = {
    // Spracovanie oznacenych eventov a ich zoskupenie
    ctCreateGroup: function() {
        try {
            $("#createGroup .ui-btn-text").html(texts.CombiOptionsCreateGroup);
            var taggedOdds = [],
                odds = $("#ticketList .checked");

            $.each(odds, function (i, odd) {
                taggedOdds.push(odd.id);
            });

            $("#ticketList .touchable-event").removeClass("event-checked");
            $('#ticketList li').removeClass("checked");

            if (taggedOdds.length) ticket.ticketCombiModule.ctTagOdd(taggedOdds);

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Oznacenie oddu/oddov do skupiny
    ctTagOdd: function(odds) {
        try {
            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                var taggedOdds = ticket.ticketCombiModule.ctIDsPrepare(odds);
                if (taggedOdds) {
                    modal.showLoading();
                    var requestUrl;
                    $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/oddtag/" + taggedOdds)
                        .done(function (data) {
                            if (data === Object(data)) {
                                if (data.Errors && !data.Errors.length) {
                                    ticket.ticket(data, null, true, true);
                                } else {
                                    var errors = modal.parseErrors(data.Errors, data.MaxBetReason);
                                    modal.showErrObj(2, 5, {errObj: errors});
                                }
                            } else {
                                main.createLog(2, "CentralTicketTagOdd_Failed", "ODDs: " + odds);
                                ticket.ticketWsRetrieve(true);
                            }
                        })
                        .fail(function (jqXHR) {
                            jqXHR.requestUrl = requestUrl;
                            main.createLog(2, "CentralTicketTagOdd_Failed", "ODDs: " + odds);
                        })
                        .always(function () {
                            modal.hideLoading();
                        });
                }
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "CentralTicketTagOdd_Failed", "ODDs: " + odds);
            modal.hideLoading();
            return false;
        }
    },

    // Odstranenie vsetkych oddov z aktivnej skupiny
    ctRemoveGroup: function() {
        try {
            var activeGroup = $("#ticketList .active-group"),
                odds = activeGroup.find('li'),
                oddsToRemove = [];
            $.each(odds, function (i, odd) {
                oddsToRemove.push(odd.id);
            });
            if (oddsToRemove.length) ticket.ticketCombiModule.ctUntagOdd(oddsToRemove);

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Odznacenie oddu/oddov do skupiny
    ctUntagOdd: function(odds) {
        try {
            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                var taggedOdds = ticket.ticketCombiModule.ctIDsPrepare(odds);
                if (taggedOdds) {
                    modal.showLoading();
                    var requestUrl;
                    $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/odduntag/" + taggedOdds)
                        .done(function (data) {
                            if (data === Object(data)) {
                                if (data.Errors && !data.Errors.length) {
                                    ticket.ticket(data, null, true, true);
                                } else {
                                    var errors = modal.parseErrors(data.Errors, data.MaxBetReason);
                                    modal.showErrObj(2, 5, {errObj: errors});
                                }
                            } else {
                                main.createLog(2, "CentralTicketUntagOdd_Failed", "ODDs: " + odds);
                                ticket.ticketWsRetrieve(true);
                            }
                        })
                        .fail(function (jqXHR) {
                            jqXHR.requestUrl = requestUrl;
                            main.createLog(2, "CentralTicketUntagOdd_Failed", "ODDs: " + odds);
                        })
                        .always(function () {
                            modal.hideLoading();
                        });
                }
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "CentralTicketUntagOdd_Failed", "ODDs: " + odds);
            modal.hideLoading();
            return false;
        }
    },

    // Oznacenie tutoviek
    ctTopOdd: function(odds) {
        try {
            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                var topOdds = ticket.ticketCombiModule.ctIDsPrepare(odds);
                if (topOdds) {
                    modal.showLoading();
                    var requestUrl;
                    $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/oddtop/" + topOdds)
                        .done(function (data) {
                            if (data === Object(data)) {
                                if (data.Errors && !data.Errors.length) {
                                    ticket.ticket(data, null, true, true);
                                } else {
                                    var errors = modal.parseErrors(data.Errors, data.MaxBetReason);
                                    modal.showErrObj(2, 5, {errObj: errors});
                                }
                            } else {
                                main.createLog(2, "CentralTicketTopOdd_Failed", "ODDs: " + odds);
                                ticket.ticketWsRetrieve(true);
                            }
                        })
                        .fail(function (jqXHR) {
                            jqXHR.requestUrl = requestUrl;
                            main.createLog(2, "CentralTicketTopOdd_Failed", "ODDs: " + odds);
                        })
                        .always(function () {
                            modal.hideLoading();
                        });
                }
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "CentralTicketTopOdd_Failed", "ODDs: " + odds);
            modal.hideLoading();
            return false;
        }
    },

    // Spracovanie tutoviek
    ctGetTopOdds: function() {
        try {
            var topOdds = [],
                odds = $("#ticketList .checked");
            $.each(odds, function (i, odd) {
                topOdds.push(odd.id);
            });
            $("#ticketList .touchable-event").removeClass("event-checked");
            $("#ticketList li").removeClass("checked");

            if (topOdds.length) ticket.ticketCombiModule.ctTopOdd(topOdds);

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Odznacenie tutoviek
    ctUntopOdd: function(odds) {
        try {
            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                var topOdds = ticket.ticketCombiModule.ctIDsPrepare(odds);
                if (topOdds) {
                    modal.showLoading();
                    var requestUrl;
                    $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/odduntop/" + topOdds)
                        .done(function (data) {
                            if (data === Object(data)) {
                                if (data.Errors && !data.Errors.length) {
                                    ticket.ticket(data, null, true, true);
                                } else {
                                    var errors = modal.parseErrors(data.Errors, data.MaxBetReason);
                                    modal.showErrObj(2, 5, {errObj: errors});
                                }
                            } else {
                                main.createLog(2, "CentralTicketUntopOdd_Failed", "ODDs: " + odds);
                                ticket.ticketWsRetrieve(true);
                            }
                        })
                        .fail(function (jqXHR) {
                            jqXHR.requestUrl = requestUrl;
                            main.createLog(2, "CentralTicketUntopOdd_Failed", "ODDs: " + odds);
                        })
                        .always(function () {
                            modal.hideLoading();
                        });
                }
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "CentralTicketUntopOdd_Failed", "ODDs: " + odds);
            modal.hideLoading();
            return false;
        }
    },

    // Zistenie oznacenych kombinacii
    ctGetCombinations: function() {
        try {
            var selectedCombi = $("#combinationList #combiButtons .ui-checkbox-on"),
                combinations = [];
            $.each(selectedCombi, function (i, combi) {
                var selected = $(combi).prev(),
                    id = $(selected).attr('id');
                combinations.push(id);
            });
            if (combinations.length) ticket.ticketCombiModule.ctActivateCombi(combinations);
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Nastavenie kombinacie pre skupinovo-rozpisovy tiket
    ctActivateCombi: function(combi) {
        try {
            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && combi) {
                modal.showLoading();
                var requestUrl;
                $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/activatecombi/" + combi)
                    .done(function (data) {
                        if (data === Object(data)) {
                            if (data.Errors && !data.Errors.length) {
                                if (stored.BetAll && data.PossibleGrossBet && data.OverallTotalBet && (profile.MinDep < data.PossibleGrossBet) && (data.PossibleGrossBet != data.OverallTotalBet)) {
                                    // Ak je mozny grossbet vacsi ako nastaveny
                                    stored.PossibleGrossBet = data.PossibleGrossBet;
                                    ticket.calc("all", true);
                                    return false;
                                } else {
                                    ticket.ticket(data, null, true, true);

                                    // Nastavenie limitov
                                    var errContainer = [];
                                    if ((errContainer = ticket.setMinMaxBet(data.MinBet, data.MaxBet, data.MaxBetReason, data.PossibleGrossBet, data.OverallTotalBet, data.IsEdited))[0]) {
                                        modal.showErrObj(2, 5, {err1: errContainer[0], err2: errContainer[1], errType: "default"});
                                    }
                                    ticket.ticketCombiModule.ctRenderCombinations(data, true, true, true);
                                    if (!stored.OverallTotalBet && !$("#depositDial").is(':visible')) ticket.depositDialToggle(false);
                                }
                            } else {
                                var errors = modal.parseErrors(data.Errors, data.MaxBetReason);
                                modal.showErrObj(2, 5, {errObj: errors});
                                ticket.ticketCombiModule.ctRenderCombinations(data, true, false, true);
                            }
                        } else {
                            main.createLog(2, "CentralTicketActivateCombi_Failed", "COMBI: " + combi);
                            ticket.ticketWsRetrieve(true);
                        }
                    })
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        main.createLog(2, "CentralTicketActivateCombi_Failed", "COMBI: " + combi);
                    })
                    .always(function () {
                        modal.hideLoading();
                    });
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "CentralTicketActivateCombi_Failed", "COMBI: " + combi);
            modal.hideLoading();
            return false;
        }
    },

    // Zrusenie kombinacie pre skupinovo-rozpisovy tiket
    ctDeactivateCombi: function(combi) {
        try {
            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && combi) {
                modal.showLoading();
                var requestUrl;
                $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/deactivatecombi/" + combi)
                    .done(function (data) {
                        if (data === Object(data)) {
                            if (data.Errors && !data.Errors.length) {
                                if (stored.BetAll && data.PossibleGrossBet && data.OverallTotalBet && (profile.MinDep < data.PossibleGrossBet) && (data.PossibleGrossBet != data.OverallTotalBet)) {
                                    // Ak je mozny grossbet vacsi ako nastaveny
                                    stored.PossibleGrossBet = data.PossibleGrossBet;
                                    ticket.calc("all", true);
                                    return false;
                                } else {
                                    ticket.ticket(data, null, true, true);

                                    // Nastavenie limitov
                                    var errContainer = [];
                                    if ((errContainer = ticket.setMinMaxBet(data.MinBet, data.MaxBet, data.MaxBetReason, data.PossibleGrossBet, data.OverallTotalBet, data.IsEdited))[0]) {
                                        modal.showErrObj(2, 5, {err1: errContainer[0], err2: errContainer[1], errType: "default"});
                                    }
                                    ticket.ticketCombiModule.ctRenderCombinations(data, false, true, true);
                                    if (!stored.OverallTotalBet && !$("#depositDial").is(':visible')) ticket.depositDialToggle(false);
                                }
                            } else {
                                var errors = modal.parseErrors(data.Errors, data.MaxBetReason);
                                modal.showErrObj(2, 5, {errObj: errors});
                            }
                        } else {
                            main.createLog(2, "CentralTicketDeactivateCombi_Failed", "COMBI: " + combi);
                            ticket.ticketWsRetrieve(true);
                        }
                    })
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        main.createLog(2, "CentralTicketDeactivateCombi_Failed", "COMBI: " + combi);
                    })
                    .always(function () {
                        modal.hideLoading();
                    });
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "CentralTicketDeactivateCombi_Failed", "COMBI: " + combi);
            modal.hideLoading();
            return false;
        }
    },

    // Predpripravenie IDs pre request
    ctIDsPrepare: function(odds) {
        try {
            if (odds) {
                odds = odds.toString();
                odds.replace(/\s/g, '');
                return odds;
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia pre zoskupenie oddov podla skupin
    ctSetGroups: function(oddID) {
        try {
            // Loteriove hry nemaju nastavitelne skupiny
            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && !ticket.state.getState().isLotteryTicket) {
                var ticketList, groups = [], g = [], group = "A";
                if (oddID) {
                    ticketList = $("#ticketList li#" + oddID);
                } else {
                    ticketList = $("#ticketList li");
                }

                $.each(ticketList, function (i, odd) {
                    g = $.extend(true, [], groups);
                    if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                        group = $(odd).attr("name");
                        if (group == "1") {
                            groups.push("T");
                        } else {
                            groups.push(group);
                        }
                    } else {
                        groups.push(group);
                        group = String.fromCharCode(group.charCodeAt(0) + 1);
                    }
                    if ((g = g.indexOf(groups[i])) == -1) {
                        $("#ticketList #" + $(odd).attr("ID")).wrapAll('<div id="group' + groups[i] + '" class="group inactive-group"></div>');
                        // Pre non FlatCSS prida tag iba do prveho oddu v ramci skupiny
                        if (!profile.FlatCSS) $("#ticketList #" + $(odd).attr("ID")).parent().prepend('<span class="group-name">' + groups[i] + '</span><div class="group-header"></div>');
                    } else {
                        // Preusporiada oddy do zvolenych skupin
                        $("#ticketList #group" + groups[g]).append($("#ticketList #" + $(odd).attr("ID")));
                    }
                    // Pre FlatCSS pridava tag do kazdeho oddu
                    if (profile.FlatCSS) $("#ticketList #" + $(odd).attr("ID")).prepend('<div class="group-line-top"></div><div class="group-line-bottom"></div><span class="group-name">' + groups[i] + '</span>');

                });
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Vyber kombinacii
    ctUpdateCombinations: function(id) {
        try {
            if (stored.actionsHandling.scrolledByTapAndHold) {
                stored.actionsHandling.scrolledByTapAndHold = false;
                return false;
            }
            // Ak prebieha zadavanie na inom vstupe tak nepovoli dalsiu akciu
            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                shared.scrollModule.scrollReload("combinationList", "save");
                var selectedCombi = document.querySelector(`#combiButtons input[id*='combi-button-${id}']`);
                if (selectedCombi.checked) {
                    ticket.ticketCombiModule.ctDeactivateCombi(id);
                } else {
                    ticket.ticketCombiModule.ctActivateCombi(id);
                }
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Nastavenie BETu podla typu tiketu
    ctSetBet: function(submitTicketAction, check, betReset, unpinAll) {
        try {
            var errContainer = null;
            if ((stored.OverallTotalBet || betReset) && !stored.FreebetID && !stored.BonificationID) {
                if (submitTicketAction) main.lockApp();
                // Simple Ticket & Combined Ticket
                var requestUrl, ticketType, requestType;
                if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                    // Kombinovany tiket
                    ticketType = ticket.state.ticketWsTypes.SRT;
                    if (!betReset) {
                        // Kombinovany tiket - nenulovy
                        requestType = "/setgrossbet/" + stored.OverallTotalBet;
                    } else {
                        // Kombinovany tiket - reset vkladu
                        requestType = "/betreset/" + unpinAll;
                    }
                } else {
                    // Jednoduchy tiket
                    ticketType = ticket.state.ticketWsTypes.JT;
                    if (!betReset) {
                        // JT - nenulovy vklad
                        requestType = "/settotalbet/" + stored.OverallTotalBet;
                    } else {
                        // JT - reset vkladu
                        requestType = "/betreset/0";
                    }

                }
                $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + requestType)
                    .done(function (data) {
                        if (data === Object(data)) {
                            // Nastavi dlzku oneskorenia pri prijme tiketu
                            ticket.state.setState({liveBetDelayMs: data.LiveBetDelayMs});
                            // Nastavi max deposit a potencionalnu vyhry
                            ticket.setMinMaxBet(data.MinBet, data.MaxBet, data.MaxBetReason, data.PossibleGrossBet, data.OverallTotalBet, data.IsEdited);
                            stored.overallPotWin = data.OverallPotWin;
                            // Ak nie su ziadne errors
                            if (data.Errors && !data.Errors.length) {
                                main.createLog(3, "CentralTicketSetBet_Success", "TYPE: " + ticketType + " # BET: " + stored.OverallTotalBet);
                                if (submitTicketAction) {

                                    // Ide na podanie tiketu
                                    ticket.submitTicket();

                                } else {
                                    ticket.state.setState({isClonedTicket: false});
                                    if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && list && list.Count) ticket.ticketCombiModule.ctRenderCombinations(data, false, true, true, true);
                                    if (data?.IsLotteryTicket) {
                                        ticket.ticket(data, null, true, true);
                                    }
                                    main.unlockApp();
                                }
                            } else {
                                var errors = modal.parseErrors(data.Errors, data.MaxBetReason, stored.OverallTotalBet);
                                modal.showErrObj(2, 5, {errObj: errors});
                                main.unlockApp();
                            }

                            // Nastavi dlzku oneskorenia pri prijme tiketu
                            ticket.state.setState({liveBetDelayMs: data.LiveBetDelayMs});

                            // Aktualizuje zobrazenie nastaveneho vkladu
                            if (check && !submitTicketAction) ticket.checkSum(data);

                        } else {
                            main.createLog(2, "CentralTicketSetBet_Failed", "TYPE: " + ticketType + " # BET: " + stored.OverallTotalBet);
                            errContainer = texts.TicketErr08;
                            ticket.ticketWsRetrieve(true);
                            main.unlockApp();
                        }
                    })
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        main.createLog(2, "CentralTicketSetBet_Failed", "TYPE: " + ticketType + " # BET: " + stored.OverallTotalBet + " # AJAX FAILED: " + JSON.stringify(jqXHR));
                        errContainer = texts.TicketErr08;
                        main.unlockApp();
                    })
                    .always(function () {
                        if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                            stored.inputElementJustSelected = true;
                            $("#depositDial #displayDial").find("#lotterySingleStakeValue").removeClass("selected-input");
                            stored.inputElement = $("#depositDial #displayDial").removeClass("pulse").addClass("selected-input");
                            if (ticket.state.getState().isLotteryTicket) {
                                main.unlockSbmButtons();
                            }
                        }
                    });

                if (errContainer) modal.showErrObj(2, 3, {err1: errContainer});
            }
            return true;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "CentralTicketSetBet_Failed", "TYPE: " + ticketType + " # BET: " + stored.OverallTotalBet);
            $(stored.inputElement).removeClass("pulse");
            errContainer = texts.TicketErr08;
            main.unlockApp();
            modal.hideLoading();
            return false;
        }
    },

    /**
     * Funkcia ktora nastavi stavku na vsetky kombinacie
     *
     * @param   isTotal = 0 manipulacny poplatok bude rozpocitany na kombinacie, prida sa k celkovej stavke
     * @param   isTotal = 1 nastavi celkovu stavku na vsetky kombinacie
     * @param   isParcial = 0 rozdeli danu stavku na kombinacie
     * @param   isParcial = 1  prideli danu stavku ku kombinaciam
     */
    ctSetCombinationStake: function(combinationsBet, combinationID, isTotal, isParcial) {
        try {
            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                modal.showLoading();
                if (typeof isTotal !== 'undefined') stored.IsTotalBet = isTotal;
                if (typeof isParcial !== 'undefined') stored.IsCombiParcial = isParcial;
                var requestUrl;
                $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/setcombinationstake/" + combinationsBet + "/istotal/" + stored.IsTotalBet + "/combinationid/" + combinationID + "/isparcial/" + stored.IsCombiParcial)
                    .done(function (data) {
                        if (data === Object(data)) {
                            // Nastavi max deposit a potencionalnu vyhry
                            var errContainer = [];
                            errContainer = ticket.setMinMaxBet(data.MinBet, data.MaxBet, data.MaxBetReason, data.PossibleGrossBet, data.OverallTotalBet, data.IsEdited);
                            stored.overallPotWin = data.OverallPotWin;
                            // Ak nie su ziadne errors
                            if (data.Errors && data.Errors.length) {
                                console.error("ERROR ctSetCombinationStake data.Errors: " + JSON.stringify(data.Errors) + " stored.overallTotalBet: " + stored.OverallTotalBet + " stored.PossibleGrossBet: " + stored.PossibleGrossBet);
                            }
                            if (data.Errors && !data.Errors.length) {
                                if (stored.BetAll && data.PossibleGrossBet && data.OverallTotalBet && (profile.MinDep < data.PossibleGrossBet) && (data.PossibleGrossBet != data.OverallTotalBet)) {
                                    // Ak je mozny grossbet vacsi ako nastaveny
                                    stored.PossibleGrossBet = data.PossibleGrossBet;
                                    ticket.calc("all", true);
                                    return false;
                                } else {
                                    ticket.ticket(data, null, true, true);
                                    // Nastavenie limitov
                                    if (!errContainer[0] && ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && !ticket.state.getState().isLotteryTicket) {
                                        // Pre loteriove hry nieje potrebne volat znova ticket.ticketCombiModule.ctRenderCombinations() - funkcia sa vola z ticket.ticket(data, null, true, true); - vedie to k duplicitnym volaniam
                                        ticket.ticketCombiModule.ctRenderCombinations(data, true, true);
                                    } else {
                                        modal.showErrObj(2, 5, {err1: errContainer[0], err2: errContainer[1], errType: "default"});
                                    }
                                }
                            } else {
                                ticket.ticketCombiModule.ctRenderCombinations(data, true, true);

                                var errors = modal.parseErrors(data.Errors, data.MaxBetReason, combinationsBet);
                                modal.showErrObj(2, 5, {err1: errors[0], err2: errors[1], errType: "default"});
                            }
                            ticket.state.setState({isClonedTicket: false});
                            ticket.checkSum(data);
                        } else {
                            main.createLog(2, "CentralTicketActivateCombi_Failed", "COMBI: " + combinationID);
                            ticket.ticketWsRetrieve(true);
                        }
                    })
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        main.createLog(2, "CentralTicketActivateCombi_Failed", "COMBI: " + combinationID);
                    })
                    .always(function () {
                        $(stored.inputElement).removeClass("pulse");
                        modal.hideLoading();
                    });
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "CentralTicketActivateCombi_Failed", "COMBI: " + combinationID);
            $(stored.inputElement).removeClass("pulse");
            modal.hideLoading();
            return false;
        }
    },

    // Funkcia ktora nastavi stavku pre jednu kombinaciu
    ctSetSpellStake: function(combinationBet, spellID, glowInputs) {
        try {
            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                modal.showLoading();
                // Ak sa jedna o zadavanie vkladu pre loteriovy tiket tak zamkne tlacitka
                if (ticket.state.getState().isLotteryTicket) {
                    main.lockSbmButtons();
                }
                var requestUrl;
                $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/setspellstake/" + combinationBet + "/istotal/" + stored.IsTotalBet + "/spell/" + spellID)
                    .done(function (data) {
                        if (data === Object(data)) {
                            if (stored.BetAll && data.PossibleGrossBet && data.OverallTotalBet && (profile.MinDep < data.PossibleGrossBet) && (data.PossibleGrossBet != data.OverallTotalBet)) {
                                // Ak je mozny grossbet vacsi ako nastaveny
                                stored.PossibleGrossBet = data.PossibleGrossBet;
                                ticket.calc("all", true);
                                return false;
                            } else {
                                // Nastavi max deposit a potencionalnu vyhry
                                ticket.setMinMaxBet(data.MinBet, data.MaxBet, data.MaxBetReason, data.PossibleGrossBet, data.OverallTotalBet, data.IsEdited);
                                stored.overallPotWin = data.OverallPotWin;
                                if (data.Errors && data.Errors.length) {
                                    console.error("ERROR ctSetSpellStake data.Errors: " + JSON.stringify(data.Errors) + " stored.overallTotalBet: " + stored.OverallTotalBet + " stored.PossibleGrossBet: " + stored.PossibleGrossBet);
                                    var errors = modal.parseErrors(data.Errors, data.MaxBetReason, combinationBet);
                                    modal.showErrObj(2, 5, {errObj: errors});
                                    ticket.ticket(data, null, true, true);
                                    main.unlockSbmButtons();
                                }
                                ticket.ticketCombiModule.ctRenderCombinations(data, false, glowInputs);
                                ticket.state.setState({isClonedTicket: false});
                                ticket.checkSum(data);
                            }
                        } else {
                            main.createLog(2, "CentralTicketActivateCombi_Failed", "SPELL: " + spellID);
                            ticket.ticketWsRetrieve(true);
                        }
                    })
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        main.createLog(2, "CentralTicketActivateCombi_Failed", "SPELL: " + spellID);
                    })
                    .always(function () {
                        $(stored.inputElement).removeClass("pulse");
                        if (ticket.state.getState().isLotteryTicket) {
                            // Nieje potrebne oznacovat input - nasleduje volanie ctUnpinCombination - vo funkcii sa oznaci spravny input
                            // ale v pripade neprazdnej Errors sa funkcia ctUnpinCombination nezavola - preto nasledujuci riadok:
                            ticket.ticketCombiModule.selectCombiInput(stored.inputElement);
                        } else {
                            stored.inputElement = $("#depositDial #displayDial").addClass("selected-input").find("#lotterySingleStakeValue").removeClass("selected-input");
                        }
                        modal.hideLoading();
                    });
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            $(stored.inputElement).removeClass("pulse");
            modal.hideLoading();
            return false;
        }
    },

    // Funkcia ktora odpinuje vklad na rozpis, vklad na kombinaciu
    ctUnpinCombination: function(combinationID, spellID, glowInputs, noUnlock) {
        try {
            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                modal.showLoading();
                var requestUrl;
                $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/unpincombination/" + combinationID + "/spell/" + spellID)
                    .done(function (data) {
                        if (data === Object(data)) {
                            if (stored.BetAll && data.PossibleGrossBet && data.OverallTotalBet && (profile.MinDep < data.PossibleGrossBet) && (data.PossibleGrossBet != data.OverallTotalBet)) {
                                stored.BetAll = false;
                                $(".bet-all .ui-btn").removeClass("ui-btn-active");
                                document.querySelector(".deposit-dial__button--all").classList.remove("deposit-dial__button--active");
                            } else {
                                // Nastavi max deposit a potencionalnu vyhry
                                ticket.setMinMaxBet(data.MinBet, data.MaxBet, data.MaxBetReason, data.PossibleGrossBet, data.OverallTotalBet, data.IsEdited);
                                stored.overallPotWin = data.OverallPotWin;
                                // Ak nie su ziadne errors
                                if (data.Errors && data.Errors.length) {
                                    var errors = modal.parseErrors(data.Errors, data.MaxBetReason);
                                    modal.showErrObj(2, 5, {errObj: errors});
                                }
                                if (combinationID == "all" && spellID == "all" && !ticket.state.getState().isLotteryTicket) {
                                    ticket.ticketCombiModule.ctSetBet(false, false, false, false);
                                } else {
                                    ticket.ticketCombiModule.ctRenderCombinations(data, false, glowInputs, false, noUnlock, data.IsLotteryTicket);
                                }
                                if (ticket.state.getState().isClonedTicket) {
                                    ticket.ticketCombiModule.ctUpdateCombiBets();
                                } 
                                ticket.checkSum(data);
                            }
                        } else {
                            main.createLog(2, "CentralTicketActivateCombi_Failed", "COMBI: " + combinationID + " SPELL: " + spellID);
                            ticket.ticketWsRetrieve(true);
                        }
                    })
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        main.createLog(2, "CentralTicketActivateCombi_Failed", "COMBI: " + combinationID + " SPELL: " + spellID);
                    })
                    .always(function () {
                        if (ticket.state.getState().isLotteryTicket) {
                            // Odomkne tlacitka
                            main.unlockSbmButtons();
                            // Pri loteria flow nieje referencia na DOM element (nastal render tiketu - vznikli nove elementy)
                            if (!$.contains(stored.inputElement)) {
                                // Neexistuje referencia, element najde v DOM podla ID aby ho nasledne ulozil do stored.inputElement a zvyraznil v UI
                                var input = $("#" + $(stored.inputElement)?.attr("id"));
                                if (input?.length) {
                                    stored.inputElement = input;
                                }
                            }
                            ticket.ticketCombiModule.selectCombiInput(stored.inputElement);
                        } else {
                            if ($("#depositDial #displayDial").hasClass("selected-input")) {
                                stored.inputElementJustSelected = true;
                                stored.inputElement = $("#depositDial #displayDial").addClass("selected-input").find("#lotterySingleStakeValue").removeClass("selected-input");
                            }
                        }
                        modal.hideLoading();
                    });
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na zobrazenie uzamknutia vkladu kombi tiketu
    ctRenderLockButton: function() {
        if (!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) return false;
        stored.BetLock = "lock";
        $("#depositDial #betLock .ui-icon").removeClass("ui-icon-unlocked");
        $("#depositDial #betRound").hide();
        $("#depositDial .bet-all").show();
    },

    // Funkcia na zobrazenie odomknutia vkladu kombi tiketu
    ctRenderUnLockButton: function() {
        if (!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) return false;
        stored.BetLock = "unlock";
        stored.BetAll = false;
        $("#depositDial #betLock .ui-icon").addClass("ui-icon-unlocked");
        $("#depositDial .bet-all").hide().find(".ui-btn").removeClass("ui-btn-active");
        document.querySelector(".deposit-dial__button--all").classList.remove("deposit-dial__button--active");
        if (stored.OverallTotalBet) {
            var totalBet = Math.ceil(stored.OverallTotalBet);
            if (stored.OverallTotalBet != totalBet) {
                $("#depositDial #betRound #betRoundValue").text(Math.ceil(stored.OverallTotalBet) + " " + profile.Currency);
                $("#depositDial #betRound").show();
            }
        }
    },

    // Funkcia na zmenu zobrazenie tlacidiel na kalkulacke - grossBet / betAll
    ctBetLock: function(keepValue, notCallBetLock) {
        try {
            // Ak prebieha zadavanie na inom vstupe alebo niesu na tikete oddy tak nepovoli dalsiu akciu
            if (stored.CombiTimerActive || !ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) || !list.Count) {
                return false;
            } else {
                modal.showLoading();
                if (ticket.state.getState().isClonedTicket) {
                    stored.BetAll = false;
                    // TODO refactor Vypinanie BET ALL pri loteriovych hrach:
                    $(".bet-all .ui-btn").removeClass("ui-btn-active");
                    document.querySelector(".deposit-dial__button--all").classList.remove("deposit-dial__button--active");
                    ticket.ticketCombiModule.ctUnpinCombination("all", "all", true);
                    ticket.ticketCombiModule.ctSetBet(false, true, false, false);
                    ticket.ticketCombiModule.ctRenderUnLockButton();
                    ticket.state.setState({isClonedTicket: false});
                    return true;
                }
                var requestUrl;
                if (!keepValue) {
                    if ($("#depositDial #betLock").find(".ui-icon").hasClass("ui-icon-unlocked")) {
                        stored.BetLock = "lock";
                        ticket.ticketCombiModule.ctRenderLockButton();
                        // Ak je vklad pri zamknuti vyzsi ako je vyskla balancu tak resetne piny na kombinacie
                        if (stored.OverallTotalBet > ticket.balance()) {
                            stored.OverallTotalBet = 0;
                            ticket.ticketCombiModule.ctSetBet(false, true, true, 0, true);
                            return true;
                        }
                    } else {
                        ticket.ticketCombiModule.ctRenderUnLockButton();
                    }
                }
                if (!notCallBetLock) {
                    $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/" + stored.BetLock)
                        .done(function (data) {
                            if (data === Object(data) && ((data.GrossBet != 0 && stored.BetLock == "lock") || (data.GrossBet == 0 && stored.BetLock == "unlock"))) {
                                if (data.Errors && data.Errors.length) {
                                    var errors = modal.parseErrors(data.Errors, data.MaxBetReason);
                                    modal.showErrObj(2, 5, {errobj: errors});
                                }
                                ticket.ticketCombiModule.ctRenderCombinations(data, false, true);
                                ticket.checkSum(data);
                            } else {
                                main.createLog(2, "CentralTicket" + stored.BetLock + "Combi_Failed");
                                ticket.ticketWsRetrieve(true);
                            }
                        })
                        .fail(function (jqXHR) {
                            jqXHR.requestUrl = requestUrl;
                            main.createLog(2, "CentralTicket" + stored.BetLock + "Combi_Failed");
                            ticket.ticketCombiModule.betLockFailed();
                        })
                        .always(function () {
                            if ($("#depositDial #displayDial").hasClass("selected-input")) {
                                stored.inputElementJustSelected = true;
                                $("#depositDial #displayDial").find("#lotterySingleStakeValue").removeClass("selected-input");
                                stored.inputElement = $("#depositDial #displayDial").addClass("selected-input");
                            }
                            modal.hideLoading();
                        });
                }
                return true;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Neuspesna zmena stavu zamknutia / odomknutia vkladu na kombinovany tiket
    betLockFailed: function() {
        try {
            if (!ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) return false;
            if (stored.BetLock == "lock") {
                stored.BetLock = "unlock";
                $("#depositDial #betLock .ui-icon").addClass("ui-icon-unlocked");
                $("#depositDial .bet-all").hide();
            } else {
                stored.BetLock = "lock";
                $("#depositDial #betLock .ui-icon").removeClass("ui-icon-unlocked");
                $("#depositDial .bet-all").show();
                $("#depositDial #betRound").hide();
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na zaokruhlenie vkladu na kombinovany tiket a jeho nasledne zamknutie
    betRound: function() {
        try {
            if (stored.OverallTotalBet) {
                var totalBet = Math.ceil(stored.OverallTotalBet);
                if (stored.OverallTotalBet != totalBet) {
                    stored.OverallTotalBet = totalBet;
                    ticket.ticketCombiModule.ctSetBet(false, true);
                }
            }
            return true;
        } catch (e) {
            $("#depositDial #betRound").hide();
            return false;
        }
    },

    // Funkcia na zmenu pohladu pri vklade na kombinaciu (rozpis/kombinacia)
    selectCombinationType: function(combiSwitch) {
        try {
            if (combiSwitch != "combiOriginalBet") {
                // Oznacenie buttonu
                document.querySelectorAll(".ticket-label-wrapper .switch-btn")
                    .forEach(button => {
                        button.classList.remove("selected-switch-btn");
                    });
                $("#" + combiSwitch).addClass('selected-switch-btn');
            }
            switch (combiSwitch) {
                case "combiNonPartial":
                    // Vklad na ROZPIS
                    stored.IsCombiParcial = 0;
                    ticket.ticketCombiModule.ctRenderCombinations(null, false, true);
                    break;
                case "combiPartial":
                    // Vklad na KOMBINACIE
                    stored.IsCombiParcial = 1;
                    ticket.ticketCombiModule.ctRenderCombinations(null, false, true);
                    break;
                case "combiOriginalBet":
                    // RESET vkladov
                    stored.IsCombiParcial = 0;
                    ticket.ticketCombiModule.ctUnpinCombination("all", "all", true, true);
                    ticket.state.setState({isClonedTicket: false});
                    break;
            }
            return true;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia ktora vola v ramci kombinovaneho tiketu automaticky po 2 sekundach od zadania hodnoty volania na prepocet vkladov
    combiInputSwitch: function() {
        try {
            var idCombi = $(stored.inputElement).attr('id'),
                combiInputValue = $(stored.inputElement).text().replace(',', '.');

            // Ak nieje cislo validne tak ho nastavi na 0
            if ((combiInputValue.substr(combiInputValue.indexOf('.') + 1) == "") || !(/\d/.test(combiInputValue)))  combiInputValue = 0;

            if ($(stored.inputElement).hasClass('combi-list__bet-value')) {
                // Zmena vkladu konkretnej KOMBINACIE
                ticket.ticketCombiModule.ctSetSpellStake(combiInputValue, $(stored.inputElement).parent().attr('id').split("combiBet")[1], false);
            } else if ($(stored.inputElement).hasClass('combi-buttons__item__input')) {
                // Zmena vkladu ROZPISU
                ticket.ticketCombiModule.ctSetCombinationStake(combiInputValue, idCombi, stored.IsTotalBet, stored.IsCombiParcial);
            } else if (idCombi === "lotterySingleStakeValue") {
                // Zmena vkladu ROZPISU loteriovych hier
                ticket.ticketCombiModule.ctSetCombinationStake(combiInputValue, "1." + String(list.Count), 1, 1);
            } else {
                // Zmena vkladu na tiket v ratane manipulacneho poplatku
                stored.Decimal = false;
                $("#calcComma .ui-btn").removeClass("ui-btn-active");
                ticket.ticketCombiModule.ctSetBet(false, true);
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia ktora aktivuje oznacene pole pre zadavanie vstupu pri kombi tikete
    selectCombiInput: function(inputElement) {
        try {
            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                // Deaktivuje desatinu ciarku
                if (stored.Decimal) {
                    stored.Decimal = false;
                    $("#calcComma .ui-btn").removeClass("ui-btn-active");
                }
                // Ak prebieha zadavanie na inom vstupe tak nepovoli dalsiu akciu
                if (stored.CombiTimerActive) {
                    return false;
                } else {
                    stored.inputElementJustSelected = true;
                    // Deaktivuje vstupy na kombi tikete
                    // Jedna kombinacia
                    $("#combiList .combi-list__row").removeClass("selected-input");
                    // Jedna kombinacia -loteria
                    $("#ticketList .lottery-combi-row").removeClass("selected-input");
                    // Mnozina kombinacii
                    $("#combiButtons .combi-buttons__item__input").removeClass("selected-input");
                    $("#depositDial").find("#displayDial, #lotterySingleStakeValue").removeClass("selected-input");

                    // Aktivuje vstup na kombi tikete
                    if ($(inputElement).hasClass("combi-buttons__item__input")) {
                        // Mnozina kombinacii
                    } else if ($(inputElement).hasClass("combi-list__bet-value")) {
                        // Jedna kombinacia
                        if (ticket.state.getState().isLotteryTicket) {
                            stored.IsTotalBet = 0;
                        }
                        stored.inputElement = $(inputElement).parent().parent().addClass('selected-input');
                    } else if ($(inputElement).attr("id") === "lotterySingleStakeValue") {
                        $("#depositDial #displayDial").removeClass("selected-input");
                        stored.inputElementJustSelected = true;
                        event.stopImmediatePropagation();
                    }
                    stored.inputElement = $(inputElement).addClass("selected-input");

                    // Otvori kalkulacku ak je zatvorena
                    if (!$("#depositDial").is(":visible")) ticket.depositDialToggle();
                    return true;
                }
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na zapinovanie / odpinovanie kombinacie na rozpisovom tikete
    pinToggle: function(pinned, spellID, combinationBet) {
        try {
            // Ak prebieha zadavanie na inom vstupe tak nepovoli dalsiu akciu
            if (stored.CombiTimerActive || !ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                return false;
            } else {
                // Oznaci a zhanse oznacenie pri PIN/UNPIN ak sa medzi tym este nevyrenderoval
                $("#combiList #combiRow" + spellID).addClass('glow');
                clearTimeout(rfs.glow);
                rfs.glow = setTimeout(function () {
                    rfs.glow = null;
                    if (pinned) {
                        ticket.ticketCombiModule.ctUnpinCombination("all", spellID, false);
                    } else {
                        ticket.ticketCombiModule.ctSetSpellStake(combinationBet, spellID, false);
                    }
                }, 200);
                return true;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            $("#combiList .combi-list__row").removeClass('glow');
            return false;
        }
    },

    // Aktualizovanie tabulky kombinacii
    ctUpdateCombiBets: function(noBetValue) {
        try {
            if (!noBetValue) {
                // Prepocet manipulacneho poplatku
                stored.OverallFee = shared.floor2(stored.OverallTotalBet - shared.floor2(stored.OverallTotalBet / stored.FeeAmount));
            } else {
                stored.OverallTotalBet = stored.OverallFee = 0;
            }

            // Vyprazdnenie tabulky kombinacii + pridanie hlavicky
            const combiList = document.querySelector("#combiList");
            const combiListRows = combiList.querySelector(".combi-list__rows");

            // Skryje list kombinacii
            combiList.hidden = true;

            // Tabulka kombinacii
            if (list.OddsCombi && list.OddsCombi.length) {
                let potWin;
                let bet;
                let betLocked = "";

                // Odpocet manipulacneho poplatku z vkladu
                if (!stored.OverallTotalBet) {
                    betLocked = " ui-disabled";
                }

                const combiTemplate = `
                    <div class="head combi-list__row combi-list__row--header">
                        <div class="combi-list__cell combi-list__cell--lock">
                            ${texts.CombiPanelLock}
                        </div>
                        <div class="combi-list__cell combi-list__cell--bet">
                            ${texts.CombiPanelBetCombination}
                        </div>
                        <div class="combi-list__cell combi-list__cell--rate">
                            ${texts.CombiPanelRate}
                        </div>
                        <div class="combi-list__cell combi-list__cell--win">
                            ${texts.CombiPanelWin}
                        </div>
                    </div>
                    ${list.OddsCombi.map((odd) => {
                        bet = shared.floor2(odd.Bet, 1);
                        potWin = `${shared.floor2(odd.PotWin, 1)} ${profile.Currency}`;

                        if (odd.Bet == 0 || !stored.OverallTotalBet || noBetValue) {
                            bet = texts.NoBetValue;
                        } else {
                            bet = `${bet} ${profile.Currency}`;
                        }

                        return `
                            <div
                                id="combiRow${odd.ID}"
                                class="combi-list__row ${odd.Bet == 0 ? "combi-list__row--faded" : ""}"
                            >
                                <div
                                    class="combi-list__cell combi-list__cell--name"
                                    onmousedown="ticket.ticketCombiModule.pinToggle(${odd.Pinned}, '${odd.ID}', ${odd.Bet});"
                                >
                                    ${odd.ID}
                                </div>
                                <div
                                    id="combiBet${odd.ID}"
                                    class="combi-list__cell combi-list__cell--bet
                                        ${odd.Pinned ? "combi-list__cell--bet-pinned" : ""}
                                        ${bet.length >= 11 ? "combi-list__cell--bet-text-small" : ""}
                                        ${betLocked}"
                                >
                                    <div
                                        onmousedown="ticket.ticketCombiModule.selectCombiInput(this);"
                                        class="combi-list__bet-value"
                                        value="${odd.Bet}">${bet}</div>
                                </div>

                                <div class="combi-list__cell combi-list__cell--rate">
                                    <span class="combi-list__rate-value">${shared.floor2(odd.Rate, 2)}</span>
                                    <div id="flg" class="combi-list__flag"></div>
                                </div>

                                <div
                                    class="cell combi-list__cell combi-list__cell--win ${potWin.length >= 11 ? "combi-list__cell--win-text-small" : ""}"
                                >
                                    ${potWin}
                                </div>
                            </div>
                        `;
                    }).join("")}
                `;
                combiListRows.innerHTML = combiTemplate;

                shared.scrollModule.scrollButtons("combi-options");
                combiList.hidden = false;
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia vrati hodnotu pre kombinácie/rozpis 
    getCombinatorValue: function(combi, isValueForRender) {
        try {
            if (stored.IsCombiParcial) {
                combiValue = combi.ParcialBet;
            } else {
                combiValue = combi.Bet;
            }
            if (isValueForRender) {
                if (combiValue == 0)
                    return texts.CombiPanelCustomBet;
                else
                    return shared.floor2(combiValue, 1);
            } else {
                return combiValue;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Zobrazenie moznych kombinacii
    ctRenderCombinations: function(data, noShow, glowInputs, lockInput, noUnlock, ticketRender) {
        try {
            modal.showLoading();
            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {

                // Ulozenie celkoveho vkladu na tiket vratane manipulacneho poplatku
                if (data && typeof data.OverallTotalBet !== "undefined") {
                    stored.OverallTotalBet = data.OverallTotalBet;
                    if (ticket.state.getState().isLotteryTicket && stored.BetLock === "lock") {
                        stored.BetLock = "unlock";
                        ticket.ticketCombiModule.ctBetLock(true);
                    } else if (stored.BetLock == "unlock" && data.GrossBet != 0 && !ticket.state.getState().isClonedTicket && noUnlock) {
                        // Nepodarilo sa odomknut vklad na tiket - Skusi znova odomknut
                        ticket.ticketCombiModule.ctBetLock(true);
                    } else if (stored.BetLock != "unlock" && data.OverallTotalBet && data.OverallTotalBet != data.GrossBet && data.MaxBet) {
                        // Nepodarilo sa zamknut vklad na tiket - Skusi znova zamknut
                        ticket.ticketCombiModule.ctBetLock(true);
                    }
                }

                // Ulozenie aktualnych kombinacii do globalnych premennych
                if (data && data.Combi) list.Combi = data.Combi;
                if (data && data.OddsCombi) list.OddsCombi = data.OddsCombi;

                // Zisti ci sa na tikete nachadza aspon jedna uzamknuta kombinacia
                stored.combiTicketAnyPinned = false;
                stored.combiTicketAllPinned = 0;

                $.each(list.OddsCombi, function (i, odd) {
                    if (odd.Pinned) {
                        stored.combiTicketAnyPinned = true;
                        stored.combiTicketAllPinned++;
                    }
                });

                if (list.OddsCombi.length && (stored.combiTicketAllPinned == list.OddsCombi.length)) {
                    stored.combiTicketAllPinned = true;
                } else {
                    stored.combiTicketAllPinned = false;
                }

                if (data?.IsLotteryTicket) {
                    // Ak sa jedna o loteriu nastavi v UI stake bet, odpinuje kombinacie/vykresli tiket nanovo ak je to potrebne
                    ticket.ticketLotteryModule.ctRenderCombinationsLottery(data, ticketRender);
                    return true;
                }

                // Toggle pre zobrazenie listu kombinacii
                if (!stored.combinationList)
                    if (noShow) {
                        ticket.ticketCombiModule.combinationBtnToggle(true, false);
                    } else {
                        ticket.ticketCombiModule.showCombinationList();
                        ticket.depositDialToggle(false, true);
                    }

                // Aktualizovanie tabulky kombinacii
                ticket.ticketCombiModule.ctUpdateCombiBets();

                // Checkboxes
                const ticketBet = document.getElementById("ticketBet");
                const combiButtons = document.getElementById("combiButtons");
                if (stored.OverallTotalBet) {
                    ticketBet.removeAttribute("class");
   
                    ticketBet.querySelectorAll(".switch-btn").forEach(button => {
                        button.classList.remove("selected-switch-btn");
                    });

                    if (stored.IsCombiParcial) {
                        document.getElementById("combiPartial").classList.add("selected-switch-btn");
                    } else {
                        document.getElementById("combiNonPartial").classList.add("selected-switch-btn");
                    }
                } else {
                    ticketBet.classList.add("non-ui-disabled");
                }

                combiButtons.innerHTML = "";

                if (list.Combi.length > 0) {
                    var checkboxes = '<div class="combi-buttons__list">', controlgroup;
                    list.Combi.checkedCombinations = list.Combi.reduce((sum, combi) => sum + ((combi.On || 0) ? 1 : 0), 0);

                    list.Combi.forEach((combi, i) => {
                        var hasInput = false;
                        var check = "";
                        if (stored.OverallTotalBet && list.Combi[i].On && list.Combi.checkedCombinations >= 2) {
                            hasInput = true;
                            check = `
                                <button
                                    onmousedown="ticket.ticketCombiModule.selectCombiInput(this)"
                                    value="${ticket.ticketCombiModule.getCombinatorValue(combi, false)}"
                                    class="combi-buttons__item__input"
                                    currency="${profile.Currency}"
                                    id="${combi.ID}">
                                    ${ticket.ticketCombiModule.getCombinatorValue(combi, true)}
                                </button>
                            `;
                        }
                        split = combi.Desc.split('('),
                        buttonLabel = `
                            <span class="combiButtons__item__checkbox__label__name">
                                ${split[0]}
                            </span>
                            <span class="combi-buttons__item__checkbox__label__count">
                                (${split[1].substring(0, split[1].length - 1)} ${texts.CombiPanelCombinationsShortcut})
                            </span>
                        `;
                        checkboxes += `
                            <div class="combi-buttons__item">
                                <div class="combi-buttons__item__checkbox custom-checkbox custom-checkbox-combi-button
                                ${(combi.On && hasInput) ? "has-input" : ""}"
                                onclick="ticket.ticketCombiModule.ctUpdateCombinations('${combi.ID}')">
                                    <div class="ui-checkbox">
                                        <input 
                                            type="checkbox"
                                            ${(combi.On) ? "checked" : ""}
                                            id="combi-button-${combi.ID}"
                                        />
                                    </div>
                                    <label class="combi-buttons__item__checkbox__label" for="combi-button-${combi.ID}">
                                        ${buttonLabel}
                                    </label>
                                </div>
                                ${check}
                            </div>
                        `;
                    });

                    checkboxes += '</div>';
                    // Vyrenderuje combinationList
                    combiButtons.innerHTML = checkboxes;
                    if (list.Combi.checkedCombinations) {
                        // Vybrana aspon jedna kombinacna mnozina - zobrazi tlacitka zadania typu vkladov a tlacitko povodne vklady
                        ticketBet.hidden = false;
                    } else {
                        // Nevybrana ziadna kombinacna mnozina - skryje tlacitka zadania typu vkladov a tlacitko povodne vklady
                        ticketBet.hidden = true;
                    }
                    $("#combinationList #triangle").removeClass("withOneButton withMultipleButtons");
                    list.Combi.length < 2 ? $("#combinationList #triangle").addClass("withOneButton") : $("#combinationList #triangle").addClass("withMultipleButtons");
                    shared.scrollModule.scrollReload("combinationList", "reload");
                    // Zrusenie fokusu
                    if (!data?.IsLotteryTicket && $(stored.inputElement) && (!lockInput && $(stored.inputElement) && $(stored.inputElement).is("[id='displayDial']") || !($(stored.inputElement).is("[id='displayDial']")))) {
                        stored.inputElement = null;
                    }
                    if (glowInputs) {
                        clearTimeout(rfs.glow);
                        $("#combiList .combi-list__cell--bet, #combiButtons .combi-buttons__item__input, #depositDial #displayDial").removeClass('glow').addClass('glow');
                        rfs.glow = setTimeout(function () {
                            $("#combiList .combi-list__cell--bet, #combiButtons .combi-buttons__item__input, #depositDial #displayDial").removeClass('glow');
                            rfs.glow = null;
                        }, 1000);
                    }

                } else {
                    // Ziadne kombinacie - zasunutie panelu, disablovanie tlacitok
                    ticket.ticketCombiModule.hideCombinationList(true);
                    $("#markTopMatch").addClass("ui-disabled");
                    $("#createGroup").addClass("ui-disabled");
                    $("#removeGroup").addClass("ui-disabled");
                }
                if (profile.Resolution === "1280x1024") {
                    shared.scrollModule.scrollButtons("combi-options", 303);
                } else {
                    shared.scrollModule.scrollButtons("combi-options");
                }
            }

            modal.hideLoading();
            return true;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            modal.hideLoading();
            return false;
        }
    },

    // Funkcia na kontrolu kombinacii
    checkCombinations: function() {
        try {
            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && !list.OddsCombi.length) {
                if (!parseFloat(stored.Rate)) ticket.ticketCombiModule.showCombinationList();
                if (!$("#depositDial").is(':visible')) ticket.depositDialToggle();
                $(stored.inputElement).removeClass("pulse");
                $('#combinationList').addClass('glow');
                setTimeout(function () {
                    $('#combinationList').removeAttr('class');
                }, 3000);
                return true;

            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Aktualizacia kurzov v tabulke kombinacii
    combiTableDeltaUpdate: function(group) {
        try {
            var row = $('#combiList #combiRow' + group.ID),
                rate = $('#combiList #combiRow' + group.ID + ' .combi-list__rate-value').text();
            if (group.Rate) {
                if (rate > group.Rate) {
                    row.find("#flg").removeClass("ArrD, ArrU").addClass("ArrD");
                } else {
                    row.find("#flg").removeClass().addClass("ArrU");
                }
                $('#combiList #combiRow' + group.ID + ' .combi-list__rate-value').text(group.Rate.toFixed(2));
                $('#combiList #combiRow' + group.ID + ' .combi-list__cell--win').text(group.PotWin + " " + profile.Currency);
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Toggle funkcia pre combi options
    combiOptionToggle: function() {
        try {
            if ($("#ticketList .checked").length) {
                $("#markTopMatch").removeClass("ui-disabled");
                $("#createGroup").removeClass("ui-disabled");
            } else {
                $("#markTopMatch").addClass("ui-disabled");
                $("#createGroup").addClass("ui-disabled");
                $("#removeGroup").addClass("ui-disabled");
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Toggle funkcia na combination button
    combinationBtnToggle: function(btnShowList, buttonOff) {
        try {
            var combinationBtn = $("#footer-sidebar #combinationListBtn");
            // Nastavi tlacitko na: Skryt kombinacie (kombiacie su zobrazene)
            if (!btnShowList) {
                combinationBtn.attr("onclick", "ticket.ticketCombiModule.hideCombinationList();").removeClass("ui-disabled");
                combinationBtn.find(".ui-btn-text").html(texts.CombiOptionsHideCombinations);
                shared.scrollModule.scrollButtons("combi-options");
                stored.combinationList = true;
            } else {
                // Nastavi tlacitko na: Zobrazit kombinacie (kombiacie su skryte)
                if (buttonOff || !list.Odds.length) {
                    combinationBtn.addClass("ui-disabled");
                } else {
                    combinationBtn.removeClass("ui-disabled");
                }
                combinationBtn.attr("onclick", "ticket.ticketCombiModule.showCombinationList();");
                combinationBtn.find(".ui-btn-text").html(texts.CombiOptionsShowCombinations);
                stored.combinationList = false;
            }
            if (list.Odds.length) {
                combinationBtn.removeClass("ui-disabled");
            } else {
                combinationBtn.addClass("ui-disabled");
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Zobrazenie listu kombinacii
    showCombinationList: function() {
        try {
            if (!ticket.state.getState().isLotteryTicket && !stored.combinationList && list.Count) {
                if ($("#rateChangesList").is(':visible')) {
                    $("#rateChanges").removeClass("list-opened");
                    $("#footer-sidebar .rate-changes-btn .ui-btn-text").html(texts.RateChangeShow);
                    $("#rateChangesList").hide();
                }
                ticket.ticketCombiModule.combinationBtnToggle(false);
                $("#combinationList").show();
                $("#hideOffer").addClass("hide-offer-active");
                shared.scrollModule.scrollButtons("combi-options");
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Skrytie listu kombinacii
    hideCombinationList: function(buttonOff) {
        try {
            ticket.ticketCombiModule.combinationBtnToggle(true, buttonOff);
            $("#combinationList").hide();
            if (!$("#depositDial").is(":visible")) $("#hideOffer").removeClass();
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funckia na obsluhu zadavania vkladu na ROZPIS a KOMBINACIE
    calcCombi: function(value) {
        try {
            var inputInteger, inputDecimal, inputEnteredValue;
            if (value == "all") return true;
            stored.ActualEditedInput = $(stored.inputElement).text();

            // Kontrola desatinej ciarky
            if (stored.ActualEditedInput.includes(',')) {
                // Ak zada najprv desatinu ciarku tak pred nu vlozi nulu
                if (value == "comma" && stored.inputElementJustSelected || !stored.ActualEditedInput) {
                    inputEnteredValue = "0,";
                    stored.inputElementJustSelected = false;
                }
                inputInteger = stored.ActualEditedInput.substr(0, stored.ActualEditedInput.indexOf(','));
                inputDecimal = stored.ActualEditedInput.substr(stored.ActualEditedInput.indexOf(',') + 1);
            } else {
                inputInteger = Number(stored.ActualEditedInput);
                if (inputInteger == 0 && value == "0") return true;
            }
            switch (value) {
                // Zmazat vklad
                case "clear":
                    if (stored.ActualEditedInput || ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                        inputEnteredValue = 0;
                        stored.inputElementJustSelected = false;
                    }
                    break;
                case "comma":
                    if (!inputDecimal && !isNaN(inputInteger)) { 
                        if (stored.ActualEditedInput.includes(',')) return true;
                        inputEnteredValue = stored.ActualEditedInput + ",";
                    }
                    break;
                // Zmena hodnoty kombi
                default:
                    if (stored.inputElementJustSelected) {
                        inputEnteredValue = value;
                        stored.inputElementJustSelected = false;
                    } else {
                        inputEnteredValue = stored.ActualEditedInput + value;
                    }
            }
            $(stored.inputElement).text(inputEnteredValue).attr("value", inputEnteredValue);

            return true;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    }
};
